function buildPrimitiveState(topo, indexU32) {
  const prim = {
    topology: topo === 1 ? "point-list" : topo === 2 ? "line-list" : topo === 3 ? "line-strip" : "triangle-strip"
  };
  if (topo < 4) {
    prim.cullMode = "none";
  }
  if (topo > 2) {
    prim.stripIndexFormat = indexU32 ? "uint32" : "uint16";
  }
  return prim;
}

export { buildPrimitiveState };
//# sourceMappingURL=pbr-primitive-topology.js.map
